module.exports = __webpack_public_path__ + "static/media/OT3@2x.a425add7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OT/OT3@2x.png
// module id = 713
// module chunks = 0